module.exports = __webpack_public_path__ + "static/media/trøtt.531c24c3.mp3";